(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Custom Filters & Sort Dropdown toggling
  document.addEventListener('DOMContentLoaded', () => {
    window.initializePriceSliders = () => {
      // Sync manual size filters from query parameters
      const url = new URL(window.location.href);
      const activeSizes = url.searchParams.getAll('filter.p.m.custom.size');
      document.querySelectorAll('.size-filter-btn[data-param-name="filter.p.m.custom.size"]').forEach(btn => {
        const val = btn.getAttribute('data-value');
        if (activeSizes.includes(val)) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });

      document.querySelectorAll('.price-slider-container').forEach(container => {
        const sliderMin = container.querySelector('[data-slider-min]');
        const sliderMax = container.querySelector('[data-slider-max]');
        const priceWrapper = container.closest('.filter-group__price');
        const inputMin = priceWrapper ? priceWrapper.querySelector('[data-price-min]') : null;
        const inputMax = priceWrapper ? priceWrapper.querySelector('[data-price-max]') : null;
        const track = container.querySelector('.price-slider-track');

        if (!sliderMin || !sliderMax || !track) return;

        const minVal = parseInt(sliderMin.min) || 0;
        const maxVal = parseInt(sliderMin.max) || 10000;

        function updateSlider(e) {
          let valMin = parseInt(sliderMin.value);
          let valMax = parseInt(sliderMax.value);

          if (valMax - valMin < 0) {
            if (e && e.target === sliderMin) {
              sliderMin.value = valMax;
              valMin = valMax;
            } else {
              sliderMax.value = valMin;
              valMax = valMin;
            }
          }

          if (inputMin) inputMin.value = valMin;
          if (inputMax) inputMax.value = valMax;

          const percentLeft = ((valMin - minVal) / (maxVal - minVal)) * 100;
          const percentRight = 100 - (((valMax - minVal) / (maxVal - minVal)) * 100);

          track.style.left = percentLeft + '%';
          track.style.right = percentRight + '%';
        }

        function handleHover(e) {
          const rect = container.getBoundingClientRect();
          const clientX = e.clientX;
          if (clientX === undefined) return;
          const mouseX = clientX - rect.left;
          const pct = mouseX / rect.width;
          const currentHoverVal = minVal + pct * (maxVal - minVal);
          
          const valMin = parseInt(sliderMin.value);
          const valMax = parseInt(sliderMax.value);

          if (Math.abs(currentHoverVal - valMax) < Math.abs(currentHoverVal - valMin)) {
            sliderMax.style.zIndex = '15';
            sliderMin.style.zIndex = '5';
          } else {
            sliderMin.style.zIndex = '15';
            sliderMax.style.zIndex = '5';
          }
        }

        container.addEventListener('mousemove', handleHover);

        // Mobile Touch Handling for overlapping thumbs proximity dragging
        let activeSlider = null;

        function onTouchStart(e) {
          const rect = container.getBoundingClientRect();
          const touch = e.touches[0];
          const mouseX = touch.clientX - rect.left;
          const pct = Math.max(0, Math.min(1, mouseX / rect.width));
          const currentVal = minVal + pct * (maxVal - minVal);

          const valMin = parseInt(sliderMin.value);
          const valMax = parseInt(sliderMax.value);

          const distMin = Math.abs(currentVal - valMin);
          const distMax = Math.abs(currentVal - valMax);

          if (distMin < distMax) {
            activeSlider = sliderMin;
            sliderMin.style.zIndex = '15';
            sliderMax.style.zIndex = '5';
          } else {
            activeSlider = sliderMax;
            sliderMin.style.zIndex = '5';
            sliderMax.style.zIndex = '15';
          }

          updateValueFromTouch(touch);
        }

        function onTouchMove(e) {
          if (!activeSlider) return;
          const touch = e.touches[0];
          updateValueFromTouch(touch);
          if (e.cancelable) {
            e.preventDefault(); // Stop mobile screen scrolling while dragging range slider
          }
        }

        function onTouchEnd() {
          activeSlider = null;
        }

        function updateValueFromTouch(touch) {
          const rect = container.getBoundingClientRect();
          const mouseX = touch.clientX - rect.left;
          const pct = Math.max(0, Math.min(1, mouseX / rect.width));
          const currentVal = Math.round(minVal + pct * (maxVal - minVal));

          const valMin = parseInt(sliderMin.value);
          const valMax = parseInt(sliderMax.value);

          if (activeSlider === sliderMin) {
            if (currentVal <= valMax) {
              sliderMin.value = currentVal;
            } else {
              sliderMin.value = valMax;
            }
          } else {
            if (currentVal >= valMin) {
              sliderMax.value = currentVal;
            } else {
              sliderMax.value = valMin;
            }
          }

          updateSlider();
        }

        container.addEventListener('touchstart', onTouchStart, { passive: false });
        container.addEventListener('touchmove', onTouchMove, { passive: false });
        container.addEventListener('touchend', onTouchEnd);

        function updateInputs(e) {
          let valMin = parseInt(inputMin.value) || 0;
          let valMax = parseInt(inputMax.value) || maxVal;

          if (valMin < minVal) valMin = minVal;
          if (valMin > maxVal) valMin = maxVal;
          if (valMax < minVal) valMax = minVal;
          if (valMax > maxVal) valMax = maxVal;

          if (valMax - valMin < 0) {
            if (e && e.target === inputMin) {
              valMin = valMax;
            } else {
              valMax = valMin;
            }
          }

          sliderMin.value = valMin;
          sliderMax.value = valMax;

          const percentLeft = ((valMin - minVal) / (maxVal - minVal)) * 100;
          const percentRight = 100 - (((valMax - minVal) / (maxVal - minVal)) * 100);

          track.style.left = percentLeft + '%';
          track.style.right = percentRight + '%';
        }

        function updateSliderFromInputs() {
          let valMin = (inputMin && inputMin.value !== '') ? parseInt(inputMin.value) : minVal;
          let valMax = (inputMax && inputMax.value !== '') ? parseInt(inputMax.value) : maxVal;

          sliderMin.value = valMin;
          sliderMax.value = valMax;

          const percentLeft = ((valMin - minVal) / (maxVal - minVal)) * 100;
          const percentRight = 100 - (((valMax - minVal) / (maxVal - minVal)) * 100);

          track.style.left = percentLeft + '%';
          track.style.right = percentRight + '%';
        }

        sliderMin.addEventListener('input', updateSlider);
        sliderMax.addEventListener('input', updateSlider);

        if (inputMin) inputMin.addEventListener('change', updateInputs);
        if (inputMax) inputMax.addEventListener('change', updateInputs);

        // Run initial calculation from inputs to preserve values on load
        updateSliderFromInputs();
      });

      if (typeof window.updateClearAllButton === 'function') {
        window.updateClearAllButton();
      }

      // Client-side filtering for custom size metafield
      window.filterProductsBySelectedSizes = () => {
        const activeSizes = url.searchParams.getAll('filter.p.m.custom.size').map(s => s.toLowerCase().trim());
        const cards = document.querySelectorAll('[data-product-card]');
        const grid = document.querySelector('.grid, .kids-grid') || document.querySelector('.collection-layout-wrapper .grid') || document.querySelector('.grid.grid-cols-2');
        const emptyState = document.querySelector('.collection-empty, .kids-empty-clean');

        if (activeSizes.length === 0) {
          cards.forEach(card => {
            card.style.display = '';
          });
          if (emptyState) emptyState.style.display = 'none';
          if (grid) grid.style.display = '';
          return;
        }

        let visibleCount = 0;
        cards.forEach(card => {
          const sizesAttr = card.getAttribute('data-product-sizes') || '';
          const productSizes = sizesAttr.split(',').map(s => s.trim()).filter(s => s !== '');
          const match = productSizes.some(sz => activeSizes.includes(sz));
          if (match) {
            card.style.display = '';
            visibleCount++;
          } else {
            card.style.display = 'none';
          }
        });

        if (visibleCount === 0) {
          if (grid) grid.style.display = 'none';
          if (emptyState) {
            emptyState.style.display = 'flex';
            emptyState.classList.add('active');
          }
        } else {
          if (grid) grid.style.display = '';
          if (emptyState) emptyState.style.display = 'none';
        }
      };

      // Client-side rendering of manual active size filter pills
      window.updateActiveSizePills = () => {
        const activeSizes = url.searchParams.getAll('filter.p.m.custom.size');
        let activeContainer = document.querySelector('.active-filters');
        
        if (!activeContainer) {
          const activeWrapper = document.querySelector('.active-filters-container') || document.querySelector('.collection-main-content') || document.querySelector('.kids-grid-section');
          if (activeWrapper) {
            activeContainer = document.createElement('div');
            activeContainer.className = 'active-filters font-sans';
            activeContainer.innerHTML = '<span class="active-filters-label">Active:</span>';
            activeWrapper.appendChild(activeContainer);
          }
        }

        if (!activeContainer) return;

        // Clean up previously added custom pills to prevent duplication
        activeContainer.querySelectorAll('[data-remove-size-pill]').forEach(pill => pill.remove());

        if (activeSizes.length > 0) {
          activeContainer.style.display = 'flex';
          const clearAllBtn = activeContainer.querySelector('.clear-all-filters-btn');

          activeSizes.forEach(sz => {
            const pill = document.createElement('a');
            pill.href = '#';
            pill.className = 'active-filter-pill group';
            pill.setAttribute('data-remove-size-pill', sz);
            pill.innerHTML = `
              <span class="active-filter-pill-text">Size: <strong>${sz.toUpperCase()}</strong></span>
              <i class="material-symbols-outlined ph-light ph-x active-filter-pill-close"></i>
            `;

            pill.addEventListener('click', (e) => {
              e.preventDefault();
              const currentUrl = new URL(window.location.href);
              const remainingSizes = currentUrl.searchParams.getAll('filter.p.m.custom.size').filter(s => s !== sz);
              currentUrl.searchParams.delete('filter.p.m.custom.size');
              remainingSizes.forEach(s => currentUrl.searchParams.append('filter.p.m.custom.size', s));
              currentUrl.searchParams.delete('page');

              const kidsPage = document.querySelector('.kids-page');
              if (kidsPage && typeof window.fetchAndRenderFilters === 'function') {
                window.history.pushState(null, '', currentUrl.toString());
                window.fetchAndRenderFilters(currentUrl.toString(), true);
              } else {
                window.location.href = currentUrl.toString();
              }
            });

            if (clearAllBtn) {
              activeContainer.insertBefore(pill, clearAllBtn);
            } else {
              activeContainer.appendChild(pill);
            }
          });

          // Add Clear All if missing
          if (!activeContainer.querySelector('.clear-all-filters-btn')) {
            const clearBtn = document.createElement('a');
            clearBtn.className = 'clear-all-filters-btn';
            clearBtn.href = window.location.pathname + (url.searchParams.get('sort_by') ? `?sort_by=${url.searchParams.get('sort_by')}` : '');
            clearBtn.textContent = 'Clear All';

            const kidsPage = document.querySelector('.kids-page');
            if (kidsPage && typeof window.fetchAndRenderFilters === 'function') {
              clearBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const cleanUrl = new URL(clearBtn.href);
                window.history.pushState(null, '', cleanUrl.toString());
                window.fetchAndRenderFilters(cleanUrl.toString(), true);
              });
            }

            activeContainer.appendChild(clearBtn);
          }
        } else {
          const otherPills = activeContainer.querySelectorAll('.active-filter-pill:not([data-remove-size-pill])');
          if (otherPills.length === 0) {
            activeContainer.style.display = 'none';
          }
        }
      };

      window.updateClearAllButton = () => {
        const urlParams = new URLSearchParams(window.location.search);
        let hasActiveFilters = false;
        for (const key of urlParams.keys()) {
          if (key.startsWith('filter.')) {
            hasActiveFilters = true;
            break;
          }
        }
        document.querySelectorAll('[data-clear-all-filters]').forEach(btn => {
          if (hasActiveFilters) {
            btn.classList.remove('hidden');
            btn.style.display = 'flex';
          } else {
            btn.classList.add('hidden');
            btn.style.display = 'none';
          }
        });
      };

      window.filterProductsBySelectedSizes();
      window.updateActiveSizePills();
      window.updateClearAllButton();
    };

    window.initializePriceSliders();

    const filtersToggleBtn = document.querySelector('[data-filters-toggle]');
    const filtersPanel = document.querySelector('.custom-filters-panel');
    const filtersCloseBtn = document.querySelector('[data-filters-close]');
    
    const sortToggleBtn = document.querySelector('[data-sort-toggle]');
    const sortPanel = document.querySelector('.custom-sort-panel');
    const sortChevron = document.querySelector('[data-sort-chevron]');
    const sortCloseBtn = document.querySelector('[data-sort-close]');

    const mobileSortTrigger = document.querySelector('[data-mobile-sort-trigger]');
    const mobileFilterTrigger = document.querySelector('[data-mobile-filter-trigger]');
    const mobileOverlay = document.querySelector('[data-collection-mobile-overlay]');

    // Relocate panels to avoid transform container clipping on mobile
    if (window.innerWidth < 992) {
      const collectionPage = document.querySelector('.collection-page');
      if (collectionPage) {
        if (filtersPanel) collectionPage.appendChild(filtersPanel);
        if (sortPanel) collectionPage.appendChild(sortPanel);
      }
    }

    function openPanel(type) {
      closeAllDropdowns();
      const isMobile = window.innerWidth < 992;
      if (type === 'filters' && filtersPanel) {
        filtersPanel.style.display = 'flex';
        if (isMobile) {
          if (mobileOverlay) mobileOverlay.style.display = 'block';
          document.documentElement.classList.add('drawer-open');
        }
      } else if (type === 'sort' && sortPanel) {
        sortPanel.style.display = 'block';
        if (isMobile) {
          if (mobileOverlay) mobileOverlay.style.display = 'block';
          document.documentElement.classList.add('drawer-open');
        } else {
          if (sortChevron) sortChevron.style.transform = 'rotate(180deg)';
        }
      }
    }

    function closeAllDropdowns() {
      if (filtersPanel) filtersPanel.style.display = 'none';
      if (sortPanel) {
        sortPanel.style.display = 'none';
        if (sortChevron) sortChevron.style.transform = 'rotate(0deg)';
      }
      if (mobileOverlay) mobileOverlay.style.display = 'none';
      document.documentElement.classList.remove('drawer-open');
    }

    if (filtersToggleBtn) {
      filtersToggleBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        const isVisible = filtersPanel && filtersPanel.style.display === 'block';
        if (isVisible) {
          closeAllDropdowns();
        } else {
          openPanel('filters');
        }
      });
    }

    if (filtersCloseBtn) {
      filtersCloseBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        closeAllDropdowns();
      });
    }

    if (sortToggleBtn) {
      sortToggleBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        const isVisible = sortPanel && sortPanel.style.display === 'block';
        if (isVisible) {
          closeAllDropdowns();
        } else {
          openPanel('sort');
        }
      });
    }

    if (sortCloseBtn) {
      sortCloseBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        closeAllDropdowns();
      });
    }

    if (mobileSortTrigger) {
      mobileSortTrigger.addEventListener('click', (e) => {
        e.stopPropagation();
        openPanel('sort');
      });
    }

    if (mobileFilterTrigger) {
      mobileFilterTrigger.addEventListener('click', (e) => {
        e.stopPropagation();
        openPanel('filters');
      });
    }

    if (mobileOverlay) {
      mobileOverlay.addEventListener('click', () => {
        closeAllDropdowns();
      });
    }

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-filters-close]') || e.target.closest('[data-sort-close]')) {
        e.stopPropagation();
        closeAllDropdowns();
        return;
      }

      if (filtersPanel && filtersPanel.contains(e.target)) return;
      if (sortPanel && sortPanel.contains(e.target)) return;
      if (filtersToggleBtn && filtersToggleBtn.contains(e.target)) return;
      if (sortToggleBtn && sortToggleBtn.contains(e.target)) return;
      if (mobileSortTrigger && mobileSortTrigger.contains(e.target)) return;
      if (mobileFilterTrigger && mobileFilterTrigger.contains(e.target)) return;

      closeAllDropdowns();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeAllDropdowns();
      }
    });

    // Handle Sort Selection
    document.querySelectorAll('[data-sort-option-btn]').forEach(btn => {
      btn.addEventListener('click', () => {
        const val = btn.getAttribute('data-value');
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', val);
        window.location.href = url.toString();
      });
    });

    // Handle Filter Value Toggle locally
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-filter-value-btn]');
      if (btn) {
        e.stopPropagation();
        btn.classList.toggle('active');
      }
    });

    // Handle Master Apply Filters Click
    document.addEventListener('click', (e) => {
      const applyBtn = e.target.closest('[data-apply-all-filters]');
      if (applyBtn) {
        e.stopPropagation();
        const url = new URL(window.location.href);

        // 1. Clear all existing filter parameters from URL
        const keysToDelete = [];
        for (const key of url.searchParams.keys()) {
          if (key.startsWith('filter.')) {
            keysToDelete.push(key);
          }
        }
        keysToDelete.forEach(key => url.searchParams.delete(key));

        // 2. Add currently active button filters
        document.querySelectorAll('[data-filter-value-btn].active').forEach(activeBtn => {
          const paramName = activeBtn.getAttribute('data-param-name');
          const val = activeBtn.getAttribute('data-value');
          url.searchParams.append(paramName, val);
        });

        // 3. Add price filter values
        const minInput = document.querySelector('[data-price-min]');
        const maxInput = document.querySelector('[data-price-max]');
        if (minInput) {
          const val = minInput.value.trim();
          if (val !== '') {
            url.searchParams.set(minInput.name, val);
          }
        }
        if (maxInput) {
          const val = maxInput.value.trim();
          if (val !== '') {
            url.searchParams.set(maxInput.name, val);
          }
        }

        // 4. Reset page
        url.searchParams.delete('page');

        // 5. Apply the URL
        window.location.href = url.toString();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    const input      = document.getElementById('SearchLiveInput');
    const results    = document.getElementById('SearchLiveResults');
    const clearBtn   = document.getElementById('SearchLiveClear');
    const viewAll    = document.getElementById('SearchLiveViewAll');
    const queryLabel = document.getElementById('SearchLiveQuery');

    if (!input) return;

    let debounceTimer;
    let currentQuery = '';

    function formatMoney(amount) {
      const numericAmount = parseFloat(amount);
      if (isNaN(numericAmount)) return amount;
      return '₹' + numericAmount.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }

    function showLoading() {
      results.innerHTML = '<div class="search-live__loading"><div class="search-live__spinner"></div> Searching…</div>';
      viewAll.style.display = 'none';
    }

    function showEmpty(q) {
      results.innerHTML = '<div class="search-live__empty"><i class="material-symbols-outlined ph-light ph-magnifying-glass-minus"></i>No results for "' + q + '"</div>';
      viewAll.style.display = 'none';
    }

    function renderResults(products, q) {
      if (!products || products.length === 0) {
        showEmpty(q);
        return;
      }

      const html = products.map(function(p) {
        const imgEl = p.featured_image && p.featured_image.url
          ? '<img src="' + p.featured_image.url + '" alt="' + p.title + '" class="search-result-item__thumb" width="52" height="52" loading="lazy">'
          : '<div class="search-result-item__thumb-placeholder"><i class="material-symbols-outlined ph-light ph-image"></i></div>';

        const price = p.price ? formatMoney(p.price) : '';
        const compareAt = (p.compare_at_price && p.compare_at_price > p.price)
          ? ' <s style="opacity:0.5;">' + formatMoney(p.compare_at_price) + '</s>'
          : '';

        return '<a href="' + p.url + '" class="search-result-item" role="option" tabindex="0">'
          + imgEl
          + '<div class="search-result-item__info">'
          + '<span class="search-result-item__title">' + p.title + '</span>'
          + (price ? '<span class="search-result-item__price">' + price + compareAt + '</span>' : '')
          + '</div>'
          + '</a>';
      }).join('');

      results.innerHTML = html;

      // Update view-all link
      viewAll.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
      queryLabel.textContent = q;
      viewAll.style.display = 'flex';
    }

    async function doSearch(q) {
      showLoading();
      try {
        const resp = await fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last');
        if (!resp.ok) throw new Error('Network error');
        const data = await resp.json();
        const products = data.resources && data.resources.results && data.resources.results.products;
        renderResults(products || [], q);
      } catch(e) {
        results.innerHTML = '<div class="search-live__empty"><i class="material-symbols-outlined ph-light ph-error-outline"></i>Search unavailable</div>';
        viewAll.style.display = 'none';
      }
    }

    function clearSearch() {
      input.value = '';
      currentQuery = '';
      results.innerHTML = '';
      viewAll.style.display = 'none';
      clearBtn.style.display = 'none';
      input.focus();
    }

    input.addEventListener('input', function() {
      const q = input.value.trim();
      clearBtn.style.display = q.length > 0 ? 'flex' : 'none';

      if (q.length < 2) {
        results.innerHTML = '';
        viewAll.style.display = 'none';
        currentQuery = '';
        return;
      }

      if (q === currentQuery) return;
      currentQuery = q;

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() { doSearch(q); }, 300);
    });

    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        const q = input.value.trim();
        if (q.length > 0) {
          window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
        }
      }
    });

    clearBtn.addEventListener('click', clearSearch);

    // Auto-focus when the search drawer opens
    document.addEventListener('click', function(e) {
      const trigger = e.target.closest('[data-open-drawer="search"]');
      if (trigger) {
        setTimeout(function() { input.focus(); }, 350);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  class HeroSliderPeek extends HTMLElement {
    constructor() {
      super();
      this.current = 0;
      this.timer = null;
      this.interval = parseInt(this.dataset.speed || '4500', 10);
    }

    connectedCallback() {
      this.track = this.querySelector('[data-slider-track]');
      this.slides = Array.from(this.querySelectorAll('.hero-slider__slide'));
      this.dots = Array.from(this.querySelectorAll('.hero-slider__dot'));
      
      if (!this.track || this.slides.length === 0) return;
      this.init();
    }

    disconnectedCallback() {
      this.stopAutoPlay();
    }

    init() {
      // Synchronize active dot from native smooth scroll
      let isScrollingTimer;
      this.track.addEventListener('scroll', () => {
        window.clearTimeout(isScrollingTimer);
        isScrollingTimer = setTimeout(() => {
          this.updateActiveFromScroll();
        }, 50);
      }, { passive: true });

      // Click dots to scroll
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          this.scrollToIndex(index);
        });
      });

      // Pause on hover
      this.addEventListener('mouseenter', () => this.stopAutoPlay());
      this.addEventListener('mouseleave', () => this.startAutoPlay());

      // Touch events
      this.track.addEventListener('touchstart', () => this.stopAutoPlay(), { passive: true });
      this.track.addEventListener('touchend', () => {
        setTimeout(() => this.startAutoPlay(), 3500);
      }, { passive: true });

      this.startAutoPlay();
    }

    updateActiveFromScroll() {
      if (!this.slides[0]) return;
      const scrollLeft = this.track.scrollLeft;
      const slideWidth = this.slides[0].offsetWidth;
      const gap = 14;
      const index = Math.round(scrollLeft / (slideWidth + gap));
      const clampedIndex = Math.max(0, Math.min(index, this.slides.length - 1));
      
      if (clampedIndex !== this.current) {
        this.current = clampedIndex;
        this.updateIndicators(clampedIndex);
      }
    }

    updateIndicators(index) {
      this.dots.forEach((dot, i) => {
        const isActive = (i === index);
        dot.classList.toggle('hero-slider__dot--active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('hero-slider__slide--active', i === index);
      });
    }

    scrollToIndex(index) {
      if (!this.slides[index]) return;
      const slide = this.slides[index];
      const trackPaddingLeft = parseFloat(window.getComputedStyle(this.track).paddingLeft) || 16;
      const targetScroll = slide.offsetLeft - trackPaddingLeft;
      
      this.track.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
      this.current = index;
      this.updateIndicators(index);
    }

    startAutoPlay() {
      if (this.slides.length <= 1) return;
      this.stopAutoPlay();
      this.timer = setInterval(() => {
        const nextIndex = (this.current + 1) % this.slides.length;
        this.scrollToIndex(nextIndex);
      }, this.interval);
    }

    stopAutoPlay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  customElements.define('hero-slider-component', HeroSliderPeek);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kids"] && !Shopify.designMode) return;
  try {
    
  // Custom AJAX Filters & Sort Dropdown toggling for Kids Section
  document.addEventListener('DOMContentLoaded', () => {
    // Relocate panels to avoid transform container clipping on mobile
    function relocatePanels() {
      if (window.innerWidth < 992) {
        const kidsPage = document.querySelector('.kids-page');
        const filtersPanel = document.querySelector('.custom-filters-panel');
        const sortPanel = document.querySelector('.custom-sort-panel');
        if (kidsPage) {
          if (filtersPanel) kidsPage.appendChild(filtersPanel);
          if (sortPanel) kidsPage.appendChild(sortPanel);
        }
      }
    }
    
    relocatePanels();

    function openPanel(type) {
      closeAllDropdowns();
      const filtersPanel = document.querySelector('.custom-filters-panel');
      const sortPanel = document.querySelector('.custom-sort-panel');
      const mobileOverlay = document.querySelector('[data-collection-mobile-overlay]');
      const sortChevron = document.querySelector('[data-sort-chevron]');
      const isMobile = window.innerWidth < 992;
      
      if (type === 'filters' && filtersPanel) {
        filtersPanel.style.display = 'flex';
        if (isMobile) {
          if (mobileOverlay) mobileOverlay.style.display = 'block';
          document.documentElement.classList.add('drawer-open');
        }
      } else if (type === 'sort' && sortPanel) {
        sortPanel.style.display = 'block';
        if (isMobile) {
          if (mobileOverlay) mobileOverlay.style.display = 'block';
          document.documentElement.classList.add('drawer-open');
        } else {
          if (sortChevron) sortChevron.style.transform = 'rotate(180deg)';
        }
      }
    }

    function closeAllDropdowns() {
      const filtersPanel = document.querySelector('.custom-filters-panel');
      const sortPanel = document.querySelector('.custom-sort-panel');
      const mobileOverlay = document.querySelector('[data-collection-mobile-overlay]');
      const sortChevron = document.querySelector('[data-sort-chevron]');
      
      if (filtersPanel) filtersPanel.style.display = 'none';
      if (sortPanel) {
        sortPanel.style.display = 'none';
        if (sortChevron) sortChevron.style.transform = 'rotate(0deg)';
      }
      if (mobileOverlay) mobileOverlay.style.display = 'none';
      document.documentElement.classList.remove('drawer-open');
    }

    function hasActiveFilterParams(url) {
      for (const [key, value] of url.searchParams.entries()) {
        if (key.startsWith('filter.') || key === 'sort_by' || key === 'page') {
          return true;
        }
      }
      return false;
    }

    // AJAX rendering function
    function fetchAndRenderFilters(urlStr, forceGridUpdate = true) {
      const url = new URL(urlStr);
      const kidsPage = document.querySelector('.kids-page');
      const collectionHandle = kidsPage ? (kidsPage.getAttribute('data-collection-handle') || 'kids-bags') : 'kids-bags';
      
      // Construct AJAX fetch URL to get the collection page HTML
      const ajaxUrl = new URL(`/collections/${collectionHandle}`, window.location.origin);
      
      // Ensure preview_theme_id is passed so Shopify dev server proxies correctly
      const themeId = kidsPage ? kidsPage.getAttribute('data-theme-id') : '';
      if (themeId) {
        ajaxUrl.searchParams.set('preview_theme_id', themeId);
      }

      url.searchParams.forEach((value, key) => {
        if (key !== 'preview_theme_id') {
          ajaxUrl.searchParams.append(key, value);
        }
      });

      // Add visual loading state if updating the grid
      const grid = document.querySelector('.kids-grid');
      if (forceGridUpdate && grid) {
        grid.style.opacity = '0.4';
      }

      let responseStatus = 0;
      let responseUrl = '';
      fetch(ajaxUrl.toString())
        .then(response => {
          responseStatus = response.status;
          responseUrl = response.url;
          return response.text();
        })
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // Check if filters exist in the fetched collection
          const fetchedFiltersPanel = doc.querySelector('.custom-filters-panel');
          const hasFilters = fetchedFiltersPanel && fetchedFiltersPanel.querySelector('.filter-group-wrapper');
          
          const desktopDropdown = document.getElementById('CustomFiltersDropdown');
          const mobileTrigger = document.querySelector('[data-mobile-filter-trigger]');
          const mobileDivider = document.querySelector('.mobile-pill-divider');

          if (hasFilters) {
            if (desktopDropdown) desktopDropdown.style.display = 'block';
            if (mobileTrigger) mobileTrigger.style.display = 'flex';
            if (mobileDivider) mobileDivider.style.display = 'block';
          } else {
            if (desktopDropdown) desktopDropdown.style.display = 'none';
            if (mobileTrigger) mobileTrigger.style.display = 'none';
            if (mobileDivider) mobileDivider.style.display = 'none';
          }

          if (forceGridUpdate) {
            const newGrid = doc.querySelector('.collection-main-content .grid') || doc.querySelector('.grid');
            const kidsGrid = document.querySelector('.kids-grid');
            if (newGrid && kidsGrid) {
              kidsGrid.innerHTML = newGrid.innerHTML;
              
              // Force trigger reveal animation for AJAX loaded cards
              kidsGrid.querySelectorAll('.reveal').forEach((el, index) => {
                setTimeout(() => {
                  el.classList.add('active');
                }, index * 50);
              });
            } else if (kidsGrid) {
              const newEmpty = doc.querySelector('.collection-empty');
              if (newEmpty) {
                kidsGrid.innerHTML = `<div class="kids-empty-wrapper w-full col-span-full">${newEmpty.outerHTML}</div>`;
              } else {
                // Render detailed debug box for troubleshooting
                const htmlSnippet = html.substring(0, 1000).replace(/</g, '&lt;').replace(/>/g, '&gt;');
                kidsGrid.innerHTML = `
                  <div class="col-span-full" style="background:#fee;border:1px solid #fcc;padding:16px;color:#c00;margin:20px 0;font-family:monospace;font-size:12px;text-align:left;border-radius:6px;width:100%;">
                    <strong style="font-size:14px;">Debug: No product grid found in AJAX response!</strong><br><br>
                    <strong>Requested URL:</strong> ${ajaxUrl.toString()}<br>
                    <strong>Resolved URL:</strong> ${responseUrl}<br>
                    <strong>Status Code:</strong> ${responseStatus}<br>
                    <strong>HTML Length:</strong> ${html.length} chars<br><br>
                    <strong>Response Snippet (First 1000 chars):</strong><br>
                    <pre style="white-space:pre-wrap;background:#fff;padding:12px;border:1px solid #ddd;margin-top:8px;color:#333;max-height:300px;overflow:auto;">${htmlSnippet}</pre>
                  </div>
                `;
              }
            }
          }

          // 2. Replace active filters row
          const newActiveFilters = doc.querySelector('.active-filters-container') || doc.querySelector('.active-filters');
          const kidsActiveFilters = document.querySelector('.active-filters-container') || document.querySelector('.active-filters');
          if (newActiveFilters && kidsActiveFilters) {
            kidsActiveFilters.outerHTML = newActiveFilters.outerHTML;
          } else if (kidsActiveFilters) {
            kidsActiveFilters.innerHTML = '';
          }

          // 3. Replace product count
          const newCount = doc.querySelector('.collection-bar span');
          const kidsCount = document.querySelector('.collection-bar span');
          if (newCount && kidsCount) {
            kidsCount.textContent = newCount.textContent;
          }

          // 4. Update filters panels
          const newFiltersPanel = doc.querySelector('.custom-filters-panel');
          const kidsFiltersPanel = document.querySelector('.custom-filters-panel');
          if (newFiltersPanel && kidsFiltersPanel) {
            kidsFiltersPanel.innerHTML = newFiltersPanel.innerHTML;
            if (typeof window.initializePriceSliders === 'function') {
              window.initializePriceSliders();
            }
          }

          const newSortPanel = doc.querySelector('.custom-sort-panel');
          const kidsSortPanel = document.querySelector('.custom-sort-panel');
          if (newSortPanel && kidsSortPanel) {
            kidsSortPanel.innerHTML = newSortPanel.innerHTML;
          }

          // 5. Update sort dropdown active trigger text
          const newSortText = doc.querySelector('.dropdown-trigger-text');
          const kidsSortText = document.querySelector('.dropdown-trigger-text');
          if (newSortText && kidsSortText) {
            kidsSortText.innerHTML = newSortText.innerHTML;
          }

          // 6. Update filter badge (desktop & mobile)
          const newBadge = doc.querySelector('.filter-active-badge');
          const kidsBadgeContainers = document.querySelectorAll('.filter-active-badge-container');
          kidsBadgeContainers.forEach(container => {
            if (newBadge) {
              container.innerHTML = newBadge.outerHTML;
            } else {
              container.innerHTML = '';
            }
          });

          // 7. Update pagination
          if (forceGridUpdate) {
            const newPagination = doc.querySelector('.pagination-container') || doc.querySelector('.pagination') || doc.querySelector('.kids-pagination');
            const kidsPagination = document.querySelector('.pagination-container') || document.querySelector('.kids-pagination') || document.querySelector('.pagination');
            if (newPagination && kidsPagination) {
              kidsPagination.innerHTML = newPagination.innerHTML;
              kidsPagination.style.display = 'block';
            } else if (kidsPagination) {
              kidsPagination.style.display = 'none';
            }
          }

          // Reset opacity
          if (grid) grid.style.opacity = '1';

          // Relocate panels on mobile if viewport is small (to avoid clipping)
          relocatePanels();
        })
        .catch(error => {
          console.error('Error fetching collection via AJAX:', error);
          if (grid) grid.style.opacity = '1';
        });
    }

    // ═══ EVENT DELEGATION ═══

    // Intercept clicks on document for toggles, sorting, filters, pagination, etc.
    document.addEventListener('click', (e) => {
      // Toggle dropdown buttons (Filters / Sort)
      const filtersToggle = e.target.closest('[data-filters-toggle]');
      if (filtersToggle) {
        e.stopPropagation();
        const panel = document.querySelector('.custom-filters-panel');
        const isVisible = panel && panel.style.display === 'block';
        if (isVisible) {
          closeAllDropdowns();
        } else {
          openPanel('filters');
        }
        return;
      }

      const sortToggle = e.target.closest('[data-sort-toggle]');
      if (sortToggle) {
        e.stopPropagation();
        const panel = document.querySelector('.custom-sort-panel');
        const isVisible = panel && panel.style.display === 'block';
        if (isVisible) {
          closeAllDropdowns();
        } else {
          openPanel('sort');
        }
        return;
      }

      // Close panels buttons
      if (e.target.closest('[data-filters-close]') || e.target.closest('[data-sort-close]')) {
        e.stopPropagation();
        closeAllDropdowns();
        return;
      }

      // Mobile trigger buttons
      if (e.target.closest('[data-mobile-sort-trigger]')) {
        e.stopPropagation();
        openPanel('sort');
        return;
      }
      if (e.target.closest('[data-mobile-filter-trigger]')) {
        e.stopPropagation();
        openPanel('filters');
        return;
      }

      // Backdrop overlay
      if (e.target.closest('[data-collection-mobile-overlay]')) {
        closeAllDropdowns();
        return;
      }

      // Handle Filter Value Selection (Local Toggle)
      const filterValueBtn = e.target.closest('[data-filter-value-btn]');
      if (filterValueBtn) {
        e.stopPropagation();
        filterValueBtn.classList.toggle('active');
        return;
      }

      // Handle Master Apply Filters Click
      const applyBtn = e.target.closest('[data-apply-all-filters]');
      if (applyBtn) {
        e.stopPropagation();
        const url = new URL(window.location.href);

        // 1. Clear all existing filter parameters from URL
        const keysToDelete = [];
        for (const key of url.searchParams.keys()) {
          if (key.startsWith('filter.')) {
            keysToDelete.push(key);
          }
        }
        keysToDelete.forEach(key => url.searchParams.delete(key));

        // 2. Add currently active button filters
        document.querySelectorAll('[data-filter-value-btn].active').forEach(activeBtn => {
          const paramName = activeBtn.getAttribute('data-param-name');
          const val = activeBtn.getAttribute('data-value');
          url.searchParams.append(paramName, val);
        });

        // 3. Add price filter values
        const minInput = document.querySelector('[data-price-min]');
        const maxInput = document.querySelector('[data-price-max]');
        if (minInput) {
          const val = minInput.value.trim();
          if (val !== '') {
            url.searchParams.set(minInput.name, val);
          }
        }
        if (maxInput) {
          const val = maxInput.value.trim();
          if (val !== '') {
            url.searchParams.set(maxInput.name, val);
          }
        }

        // 4. Reset page
        url.searchParams.delete('page');

        // 5. Apply the URL via AJAX
        window.history.pushState(null, '', url.toString());
        fetchAndRenderFilters(url.toString(), true);
        closeAllDropdowns();
        return;
      }

      // Handle Sort Option Selection
      const sortOptionBtn = e.target.closest('[data-sort-option-btn]');
      if (sortOptionBtn) {
        e.stopPropagation();
        const val = sortOptionBtn.getAttribute('data-value');
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', val);
        url.searchParams.delete('page');
        window.history.pushState(null, '', url.toString());
        fetchAndRenderFilters(url.toString(), true);
        closeAllDropdowns();
        return;
      }

      // Intercept active filter pill removal and clear buttons
      const clearFilterLink = e.target.closest('.active-filter-pill, .clear-all-filters-btn, .custom-filters-panel__footer a, .collection-empty a');
      if (clearFilterLink) {
        e.preventDefault();
        const url = new URL(clearFilterLink.href);
        const currentUrl = new URL(window.location.href);
        currentUrl.search = url.search;
        window.history.pushState(null, '', currentUrl.toString());
        fetchAndRenderFilters(currentUrl.toString(), true);
        return;
      }

      // Intercept pagination links
      const pageLink = e.target.closest('.kids-pagination a, .pagination a');
      if (pageLink) {
        e.preventDefault();
        const url = new URL(pageLink.href);
        const pageVal = url.searchParams.get('page') || '1';
        const currentUrl = new URL(window.location.href);
        if (pageVal !== '1') {
          currentUrl.searchParams.set('page', pageVal);
        } else {
          currentUrl.searchParams.delete('page');
        }
        window.history.pushState(null, '', currentUrl.toString());
        fetchAndRenderFilters(currentUrl.toString(), true);
        return;
      }

      // Click outside panels to close them
      const filtersPanel = document.querySelector('.custom-filters-panel');
      const sortPanel = document.querySelector('.custom-sort-panel');
      if (filtersPanel && filtersPanel.contains(e.target)) return;
      if (sortPanel && sortPanel.contains(e.target)) return;
      closeAllDropdowns();
    });

    // ESC key to close panels
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeAllDropdowns();
      }
    });

    // Browser back/forward navigation support
    window.addEventListener('popstate', () => {
      fetchAndRenderFilters(window.location.href, true);
    });

    window.initializePriceSliders = () => {
      // Sync manual size filters from query parameters
      const url = new URL(window.location.href);
      const activeSizes = url.searchParams.getAll('filter.p.m.custom.size');
      document.querySelectorAll('.size-filter-btn[data-param-name="filter.p.m.custom.size"]').forEach(btn => {
        const val = btn.getAttribute('data-value');
        if (activeSizes.includes(val)) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });

      document.querySelectorAll('.price-slider-container').forEach(container => {
        const sliderMin = container.querySelector('[data-slider-min]');
        const sliderMax = container.querySelector('[data-slider-max]');
        const priceWrapper = container.closest('.filter-group__price');
        const inputMin = priceWrapper ? priceWrapper.querySelector('[data-price-min]') : null;
        const inputMax = priceWrapper ? priceWrapper.querySelector('[data-price-max]') : null;
        const track = container.querySelector('.price-slider-track');

        if (!sliderMin || !sliderMax || !track) return;

        const minVal = parseInt(sliderMin.min) || 0;
        const maxVal = parseInt(sliderMin.max) || 10000;

        function updateSlider(e) {
          let valMin = parseInt(sliderMin.value);
          let valMax = parseInt(sliderMax.value);

          if (valMax - valMin < 0) {
            if (e && e.target === sliderMin) {
              sliderMin.value = valMax;
              valMin = valMax;
            } else {
              sliderMax.value = valMin;
              valMax = valMin;
            }
          }

          if (inputMin) inputMin.value = valMin;
          if (inputMax) inputMax.value = valMax;

          const percentLeft = ((valMin - minVal) / (maxVal - minVal)) * 100;
          const percentRight = 100 - (((valMax - minVal) / (maxVal - minVal)) * 100);

          track.style.left = percentLeft + '%';
          track.style.right = percentRight + '%';
        }

        function handleHover(e) {
          const rect = container.getBoundingClientRect();
          const clientX = e.clientX;
          if (clientX === undefined) return;
          const mouseX = clientX - rect.left;
          const pct = mouseX / rect.width;
          const currentHoverVal = minVal + pct * (maxVal - minVal);
          
          const valMin = parseInt(sliderMin.value);
          const valMax = parseInt(sliderMax.value);

          if (Math.abs(currentHoverVal - valMax) < Math.abs(currentHoverVal - valMin)) {
            sliderMax.style.zIndex = '15';
            sliderMin.style.zIndex = '5';
          } else {
            sliderMin.style.zIndex = '15';
            sliderMax.style.zIndex = '5';
          }
        }

        container.addEventListener('mousemove', handleHover);

        // Mobile Touch Handling for overlapping thumbs proximity dragging
        let activeSlider = null;

        function onTouchStart(e) {
          const rect = container.getBoundingClientRect();
          const touch = e.touches[0];
          const mouseX = touch.clientX - rect.left;
          const pct = Math.max(0, Math.min(1, mouseX / rect.width));
          const currentVal = minVal + pct * (maxVal - minVal);

          const valMin = parseInt(sliderMin.value);
          const valMax = parseInt(sliderMax.value);

          const distMin = Math.abs(currentVal - valMin);
          const distMax = Math.abs(currentVal - valMax);

          if (distMin < distMax) {
            activeSlider = sliderMin;
            sliderMin.style.zIndex = '15';
            sliderMax.style.zIndex = '5';
          } else {
            activeSlider = sliderMax;
            sliderMin.style.zIndex = '5';
            sliderMax.style.zIndex = '15';
          }

          updateValueFromTouch(touch);
        }

        function onTouchMove(e) {
          if (!activeSlider) return;
          const touch = e.touches[0];
          updateValueFromTouch(touch);
          if (e.cancelable) {
            e.preventDefault(); // Stop mobile screen scrolling while dragging range slider
          }
        }

        function onTouchEnd() {
          activeSlider = null;
        }

        function updateValueFromTouch(touch) {
          const rect = container.getBoundingClientRect();
          const mouseX = touch.clientX - rect.left;
          const pct = Math.max(0, Math.min(1, mouseX / rect.width));
          const currentVal = Math.round(minVal + pct * (maxVal - minVal));

          const valMin = parseInt(sliderMin.value);
          const valMax = parseInt(sliderMax.value);

          if (activeSlider === sliderMin) {
            if (currentVal <= valMax) {
              sliderMin.value = currentVal;
            } else {
              sliderMin.value = valMax;
            }
          } else {
            if (currentVal >= valMin) {
              sliderMax.value = currentVal;
            } else {
              sliderMax.value = valMin;
            }
          }

          updateSlider();
        }

        container.addEventListener('touchstart', onTouchStart, { passive: false });
        container.addEventListener('touchmove', onTouchMove, { passive: false });
        container.addEventListener('touchend', onTouchEnd);

        function updateInputs(e) {
          let valMin = parseInt(inputMin.value) || 0;
          let valMax = parseInt(inputMax.value) || maxVal;

          if (valMin < minVal) valMin = minVal;
          if (valMin > maxVal) valMin = maxVal;
          if (valMax < minVal) valMax = minVal;
          if (valMax > maxVal) valMax = maxVal;

          if (valMax - valMin < 0) {
            if (e && e.target === inputMin) {
              valMin = valMax;
            } else {
              valMax = valMin;
            }
          }

          sliderMin.value = valMin;
          sliderMax.value = valMax;

          const percentLeft = ((valMin - minVal) / (maxVal - minVal)) * 100;
          const percentRight = 100 - (((valMax - minVal) / (maxVal - minVal)) * 100);

          track.style.left = percentLeft + '%';
          track.style.right = percentRight + '%';
        }

        function updateSliderFromInputs() {
          let valMin = (inputMin && inputMin.value !== '') ? parseInt(inputMin.value) : minVal;
          let valMax = (inputMax && inputMax.value !== '') ? parseInt(inputMax.value) : maxVal;

          sliderMin.value = valMin;
          sliderMax.value = valMax;

          const percentLeft = ((valMin - minVal) / (maxVal - minVal)) * 100;
          const percentRight = 100 - (((valMax - minVal) / (maxVal - minVal)) * 100);

          track.style.left = percentLeft + '%';
          track.style.right = percentRight + '%';
        }

        sliderMin.addEventListener('input', updateSlider);
        sliderMax.addEventListener('input', updateSlider);

        if (inputMin) inputMin.addEventListener('change', updateInputs);
        if (inputMax) inputMax.addEventListener('change', updateInputs);

        // Run initial calculation from inputs to preserve values on load
        updateSliderFromInputs();
      });

      if (typeof window.updateClearAllButton === 'function') {
        window.updateClearAllButton();
      }

      // Client-side filtering for custom size metafield
      window.filterProductsBySelectedSizes = () => {
        const activeSizes = url.searchParams.getAll('filter.p.m.custom.size').map(s => s.toLowerCase().trim());
        const cards = document.querySelectorAll('[data-product-card]');
        const grid = document.querySelector('.grid, .kids-grid') || document.querySelector('.kids-page .grid') || document.querySelector('.kids-grid');
        const emptyState = document.querySelector('.collection-empty, .kids-empty-clean');

        if (activeSizes.length === 0) {
          cards.forEach(card => {
            card.style.display = '';
          });
          if (emptyState) emptyState.style.display = 'none';
          if (grid) grid.style.display = '';
          return;
        }

        let visibleCount = 0;
        cards.forEach(card => {
          const sizesAttr = card.getAttribute('data-product-sizes') || '';
          const productSizes = sizesAttr.split(',').map(s => s.trim()).filter(s => s !== '');
          const match = productSizes.some(sz => activeSizes.includes(sz));
          if (match) {
            card.style.display = '';
            visibleCount++;
          } else {
            card.style.display = 'none';
          }
        });

        if (visibleCount === 0) {
          if (grid) grid.style.display = 'none';
          if (emptyState) {
            emptyState.style.display = 'flex';
            emptyState.classList.add('active');
          }
        } else {
          if (grid) grid.style.display = '';
          if (emptyState) emptyState.style.display = 'none';
        }
      };

      // Client-side rendering of manual active size filter pills
      window.updateActiveSizePills = () => {
        const activeSizes = url.searchParams.getAll('filter.p.m.custom.size');
        let activeContainer = document.querySelector('.active-filters');
        
        if (!activeContainer) {
          const activeWrapper = document.querySelector('.active-filters-container') || document.querySelector('.collection-main-content') || document.querySelector('.kids-grid-section');
          if (activeWrapper) {
            activeContainer = document.createElement('div');
            activeContainer.className = 'active-filters font-sans';
            activeContainer.innerHTML = '<span class="active-filters-label">Active:</span>';
            activeWrapper.appendChild(activeContainer);
          }
        }

        if (!activeContainer) return;

        // Clean up previously added custom pills to prevent duplication
        activeContainer.querySelectorAll('[data-remove-size-pill]').forEach(pill => pill.remove());

        if (activeSizes.length > 0) {
          activeContainer.style.display = 'flex';
          const clearAllBtn = activeContainer.querySelector('.clear-all-filters-btn');

          activeSizes.forEach(sz => {
            const pill = document.createElement('a');
            pill.href = '#';
            pill.className = 'active-filter-pill group';
            pill.setAttribute('data-remove-size-pill', sz);
            pill.innerHTML = `
              <span class="active-filter-pill-text">Size: <strong>${sz.toUpperCase()}</strong></span>
              <i class="material-symbols-outlined ph-light ph-x active-filter-pill-close"></i>
            `;

            pill.addEventListener('click', (e) => {
              e.preventDefault();
              const currentUrl = new URL(window.location.href);
              const remainingSizes = currentUrl.searchParams.getAll('filter.p.m.custom.size').filter(s => s !== sz);
              currentUrl.searchParams.delete('filter.p.m.custom.size');
              remainingSizes.forEach(s => currentUrl.searchParams.append('filter.p.m.custom.size', s));
              currentUrl.searchParams.delete('page');

              const kidsPage = document.querySelector('.kids-page');
              if (kidsPage && typeof window.fetchAndRenderFilters === 'function') {
                window.history.pushState(null, '', currentUrl.toString());
                window.fetchAndRenderFilters(currentUrl.toString(), true);
              } else {
                window.location.href = currentUrl.toString();
              }
            });

            if (clearAllBtn) {
              activeContainer.insertBefore(pill, clearAllBtn);
            } else {
              activeContainer.appendChild(pill);
            }
          });

          // Add Clear All if missing
          if (!activeContainer.querySelector('.clear-all-filters-btn')) {
            const clearBtn = document.createElement('a');
            clearBtn.className = 'clear-all-filters-btn';
            clearBtn.href = window.location.pathname + (url.searchParams.get('sort_by') ? `?sort_by=${url.searchParams.get('sort_by')}` : '');
            clearBtn.textContent = 'Clear All';

            const kidsPage = document.querySelector('.kids-page');
            if (kidsPage && typeof window.fetchAndRenderFilters === 'function') {
              clearBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const cleanUrl = new URL(clearBtn.href);
                window.history.pushState(null, '', cleanUrl.toString());
                window.fetchAndRenderFilters(cleanUrl.toString(), true);
              });
            }

            activeContainer.appendChild(clearBtn);
          }
        } else {
          const otherPills = activeContainer.querySelectorAll('.active-filter-pill:not([data-remove-size-pill])');
          if (otherPills.length === 0) {
            activeContainer.style.display = 'none';
          }
        }
      };

      window.updateClearAllButton = () => {
        const urlParams = new URLSearchParams(window.location.search);
        let hasActiveFilters = false;
        for (const key of urlParams.keys()) {
          if (key.startsWith('filter.')) {
            hasActiveFilters = true;
            break;
          }
        }
        document.querySelectorAll('[data-clear-all-filters]').forEach(btn => {
          if (hasActiveFilters) {
            btn.classList.remove('hidden');
            btn.style.display = 'flex';
          } else {
            btn.classList.add('hidden');
            btn.style.display = 'none';
          }
        });
      };

      window.filterProductsBySelectedSizes();
      window.updateActiveSizePills();
      window.updateClearAllButton();
    };

    window.initializePriceSliders();

    // Initial page load behavior:
    const initialUrl = new URL(window.location.href);
    if (hasActiveFilterParams(initialUrl)) {
      // If page was loaded with active filter/sort params, fetch and replace everything
      fetchAndRenderFilters(window.location.href, true);
    } else {
      // Otherwise, just fetch the section to populate the filters panel (without replacing the grid)
      fetchAndRenderFilters(window.location.href, false);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-wishlist"]) return;
  try {
    
  class WishlistPageRenderer {
    constructor() {
      this.grid = document.getElementById('WishlistGrid');
      this.emptyState = document.getElementById('WishlistEmptyState');
      
      this.init();
    }

    init() {
      if (!window.wishlistHandler) {
        setTimeout(() => this.init(), 50);
        return;
      }
      this.render();

      // Listen for changes and update grid
      document.addEventListener('wishlist:changed', () => {
        this.render();
      });
    }

    render() {
      if (!window.wishlistHandler) return;
      const wishlist = window.wishlistHandler.getWishlist();
      
      // Filter out any simple strings that might be legacy, only render objects
      const validProducts = wishlist.filter(item => typeof item === 'object' && item.handle);

      if (validProducts.length === 0) {
        if (this.grid) this.grid.style.display = 'none';
        if (this.emptyState) this.emptyState.style.display = 'flex';
        return;
      }

      if (this.emptyState) this.emptyState.style.display = 'none';
      if (this.grid) {
        this.grid.style.display = 'grid';
        this.grid.innerHTML = '';

        validProducts.forEach((product, index) => {
          const card = document.createElement('div');
          card.className = 'product-card-wrapper reveal active';
          card.style.transitionDelay = `${index * 50}ms`;
          card.setAttribute('data-product-card', '');
          card.setAttribute('data-product-id', product.id);
          card.setAttribute('data-product-handle', product.handle);

          const raw = product.raw || {};
          const options = raw.options || [];
          const colorOption = options.find(opt => {
            const name = typeof opt === 'object' ? (opt.name || '') : String(opt);
            return name === 'Color' || name === 'Colour';
          });

          // Size Badges Extraction
          let sizeBadgesHtml = '';
          let sizesArr = [];
          if (raw.sizes) {
            if (Array.isArray(raw.sizes)) sizesArr = raw.sizes;
            else if (typeof raw.sizes === 'string' && raw.sizes.trim()) sizesArr = raw.sizes.split(',').filter(Boolean);
          }
          if (sizesArr.length === 0 && options) {
            const sizeOpt = options.find(opt => {
              const name = typeof opt === 'object' ? (opt.name || '') : String(opt);
              return name.toLowerCase() === 'size';
            });
            if (sizeOpt && sizeOpt.values) {
              sizesArr = sizeOpt.values.map(v => typeof v === 'object' ? (v.name || v.value) : String(v));
            }
          }
          if (sizesArr.length > 0) {
            sizeBadgesHtml = `
              <div class="product-card__size-badges">
                ${sizesArr.map(sz => `<span class="product-card__size-pill">${String(sz).trim().toUpperCase()}</span>`).join('')}
              </div>
            `;
          }
          
          let swatchesHtml = '';
          if (colorOption && colorOption.values && colorOption.values.length > 1) {
            const selectedVariant = raw.variants ? raw.variants.find(v => String(v.id) === String(product.selectedVariantId)) : null;
            const selectedOptions = selectedVariant ? (selectedVariant.options || []) : [];

            swatchesHtml = `
              <div class="product-card__swatches">
                ${colorOption.values.map((value, i) => {
                  const valStr = typeof value === 'object' ? (value.name || value.title || value.value || '') : String(value || '');
                  let variantImage = '';
                  const variants = raw.variants || [];
                  const matchingVariant = variants.find(v => {
                    if (!v.options) return false;
                    return v.options.some(opt => {
                      const optStr = typeof opt === 'object' ? (opt.name || opt.title || opt.value || '') : String(opt || '');
                      return optStr.toLowerCase() === valStr.toLowerCase();
                    });
                  });
                  if (matchingVariant && matchingVariant.image) {
                    variantImage = typeof matchingVariant.image === 'object' ? (matchingVariant.image.url || matchingVariant.image.src || '') : matchingVariant.image;
                  }

                  // Use the pre-resolved colorHex baked into the JSON by Liquid (includes native swatch colors).
                  // Fall back to JS keyword map for legacy saved items that only have a string value.
                  let colorHex = (typeof value === 'object' && value.colorHex) ? value.colorHex : null;

                  if (!colorHex) {
                    const colorLower = valStr.toLowerCase();
                    if (colorLower.includes('red/black') || colorLower.includes('red-black')) colorHex = 'linear-gradient(135deg, #e63946 50%, #000000 50%)';
                    else if (colorLower.includes('black') || colorLower.includes('charcoal') || colorLower.includes('dark') || colorLower.includes('ebony') || colorLower.includes('obsidian')) colorHex = '#111111';
                    else if (colorLower.includes('white') || colorLower.includes('ivory') || colorLower.includes('snow') || colorLower.includes('cream')) colorHex = '#ffffff';
                    else if (colorLower.includes('navy') || colorLower.includes('midnight')) colorHex = '#1d3557';
                    else if (colorLower.includes('maroon') || colorLower.includes('burgundy') || colorLower.includes('wine')) colorHex = '#800020';
                    else if (colorLower.includes('red') || colorLower.includes('gameon') || colorLower.includes('crimson') || colorLower.includes('scarlet')) colorHex = '#e63946';
                    else if (colorLower.includes('orange') || colorLower.includes('amber') || colorLower.includes('rust')) colorHex = '#e28743';
                    else if (colorLower.includes('olive') || colorLower.includes('khaki') || colorLower.includes('military') || colorLower.includes('army')) colorHex = '#6b705c';
                    else if (colorLower.includes('green') || colorLower.includes('mint') || colorLower.includes('sage')) colorHex = '#556b2f';
                    else if (colorLower.includes('lavender') || colorLower.includes('lilac')) colorHex = '#c8b6ff';
                    else if (colorLower.includes('purple') || colorLower.includes('violet') || colorLower.includes('plum')) colorHex = '#6a4c93';
                    else if (colorLower.includes('yellow') || colorLower.includes('gold') || colorLower.includes('mustard')) colorHex = '#e9c46a';
                    else if (colorLower.includes('sand') || colorLower.includes('beige') || colorLower.includes('nude')) colorHex = '#e0a96d';
                    else if (colorLower.includes('tan') || colorLower.includes('camel') || colorLower.includes('brown')) colorHex = '#7f5539';
                    else if (colorLower.includes('teal')) colorHex = '#008080';
                    else if (colorLower.includes('blue') || colorLower.includes('cyan') || colorLower.includes('sky')) colorHex = '#2563eb';
                    else if (colorLower.includes('pink') || colorLower.includes('rose') || colorLower.includes('blush')) colorHex = '#ffb3c1';
                    else if (colorLower.includes('grey') || colorLower.includes('gray') || colorLower.includes('silver') || colorLower.includes('slate')) colorHex = '#8d99ae';
                    else colorHex = '#8d99ae';
                  }

                  const colorLowerCheck = valStr.toLowerCase();
                  const isWhiteOrLight = colorHex === '#ffffff' || colorLowerCheck.includes('white') || colorLowerCheck.includes('cream') || colorLowerCheck.includes('ivory');

                  const isSelected = selectedOptions.some(opt => {
                    const optStr = typeof opt === 'object' ? (opt.name || opt.title || opt.value || '') : String(opt || '');
                    return optStr.toLowerCase() === valStr.toLowerCase();
                  }) || (selectedOptions.length === 0 && i === 0);

                  return `
                    <button 
                      type="button" 
                      class="${isSelected ? 'swatch-dot-active' : 'swatch-dot'}" 
                      data-swatch-value="${valStr}"
                      data-variant-img="${variantImage}"
                      style="background: ${colorHex}; ${isWhiteOrLight ? 'border: 1px solid #d1d5db;' : ''}"
                      title="${valStr}"
                    ></button>
                  `;
                }).join('')}
              </div>
            `;
          }

          let saleBadgeHtml = '';
          if (raw.compare_at_price && Number(raw.compare_at_price) > Number(raw.price)) {
            const discPrice = Number(raw.compare_at_price) - Number(raw.price);
            const discPercent = Math.round((discPrice * 100) / Number(raw.compare_at_price));
            if (discPercent > 0) {
              saleBadgeHtml = `<div class="product-badge font-sans">SAVE ${discPercent}%</div>`;
            }
          }

          let pricingHtml = '';
          if (raw.compare_at_price && Number(raw.compare_at_price) > Number(raw.price)) {
            const formattedPrice = `Rs. ${Math.round(raw.price / 100).toLocaleString('en-IN')}`;
            const formattedCompare = `Rs. ${Math.round(raw.compare_at_price / 100).toLocaleString('en-IN')}`;
            pricingHtml = `
              <span class="product-card__price font-bold text-ink">${formattedPrice}</span>
              <span class="product-card__compare-price text-mute line-through">${formattedCompare}</span>
            `;
          } else {
            pricingHtml = `
              <span class="product-card__price font-bold text-ink">${product.price}</span>
            `;
          }
          const imgSrc = (product.image && typeof product.image === 'object') ? (product.image.url || '') : (product.image || '');

          card.innerHTML = `
            <div class="product-card-hover flex flex-col w-full relative">
              <!-- Photo Container -->
              <div class="product-image-stage">
                <a href="/products/${product.handle}" class="product-card__link" aria-label="View details of ${product.title}">
                  <img class="product-image__img" src="${imgSrc}" alt="${product.title}" data-product-card-image>
                </a>
                
                ${saleBadgeHtml}

                <!-- Dynamic Size Badges (Bottom Left) -->
                ${sizeBadgesHtml}

                <!-- Quick View Eye Icon Button (Bottom Right) -->
                <button 
                  type="button" 
                  class="product-card__quick-add" 
                  data-trigger-quickview="${product.handle}" 
                  aria-label="Quick view options for ${product.title}"
                >
                  <i class="material-symbols-outlined ph-light ph-eye" style="font-size: 16px;"></i>
                </button>

                <!-- Heart (Wishlist) Button - Shifted left to make room for Close button -->
                <button 
                  type="button" 
                  class="product-card__wishlist-btn wishlisted" 
                  data-wishlist-toggle="${product.id}" 
                  style="right: 50px;"
                  aria-label="Wishlist"
                >
                  <i class="material-symbols-outlined ph-fill ph-heart"></i>
                </button>

                <!-- Extra Remove Button -->
                <button 
                  type="button" 
                  class="product-card__remove-btn" 
                  data-wishlist-toggle="${product.id}" 
                  title="Remove from Wishlist"
                >
                  <i class="material-symbols-outlined ph-light ph-x"></i>
                </button>
              </div>

              <!-- Desktop Quick View Button -->
              <button 
                type="button" 
                class="product-card__desktop-quickview hidden md:block" 
                data-trigger-quickview="${product.handle}"
              >
                Quick view
              </button>

              <!-- Details below image -->
              <div class="product-card__info font-sans">
                <a href="/products/${product.handle}" class="product-card__title font-sans">
                  ${product.title}
                </a>
                
                <div class="product-card__pricing">
                  ${pricingHtml}
                </div>

                ${swatchesHtml}
              </div>

              <!-- Serialized Product Data for Quick View -->
              <script type="application/json" class="product-card-json">
                ${JSON.stringify(raw)}
              </script>
            </div>
          `;
          
          this.grid.appendChild(card);
        });
      }
    }
  }

  // Bind renderer on load
  document.addEventListener('DOMContentLoaded', () => {
    new WishlistPageRenderer();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // ----------------------------------------------------
  // Product Gallery Component
  // ----------------------------------------------------
  class ProductGallery extends HTMLElement {
    constructor() {
      super();
      this.thumbs = Array.from(this.querySelectorAll('.product-gallery__thumb-btn'));
      this.mainImg = this.querySelector('#ProductMainImage');
      this.mainVideoContainer = this.querySelector('#ProductMainVideoContainer');
      this.lightbox = this.querySelector('#ProductLightbox');
      
      this.lightboxImg = this.querySelector('#LightboxImage');
      this.lightboxVideoContainer = this.querySelector('#LightboxVideoContainer');
      this.currentIndexSpan = this.querySelector('#GalleryCurrentIndex');
      this.lightboxIndexSpan = this.querySelector('#LightboxCurrentIndex');
      
      this.currentIndex = 0;
      this.allMedia = [];
      this.media = [];
      this.images = [];
      this.autoplayInterval = null;
      
      this.init();
    }

    init() {
      // Extract media/images list
      const productJson = document.getElementById('ProductPageJsonData');
      if (productJson) {
        try {
          const data = JSON.parse(productJson.textContent);
          this.allMedia = data.media || (data.images || []).map(img => ({
            type: 'image',
            url: img.url || img,
            alt: img.alt || ''
          }));
          this.media = [...this.allMedia];
          this.images = this.media.map(m => m.url || m.preview_url || m);
        } catch {}
      }

      // Share button click handler
      const shareBtn = this.querySelector('.product-gallery__share-btn');
      if (shareBtn) {
        shareBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const url = shareBtn.getAttribute('data-share-url') || window.location.href;
          const title = shareBtn.getAttribute('data-share-title') || document.title;
          
          if (navigator.share) {
            navigator.share({
              title: title,
              url: url
            }).catch(console.error);
          } else {
            navigator.clipboard.writeText(url).then(() => {
              const icon = shareBtn.querySelector('i');
              const originalClass = icon.className;
              icon.className = 'material-symbols-outlined ph-fill ph-check';
              shareBtn.style.backgroundColor = '#2e7d32';
              shareBtn.style.color = '#ffffff';
              shareBtn.style.borderColor = '#2e7d32';
              
              setTimeout(() => {
                icon.className = originalClass;
                shareBtn.style.backgroundColor = '';
                shareBtn.style.color = '';
                shareBtn.style.borderColor = '';
              }, 2000);
            }).catch(err => {
              console.error('Failed to copy text: ', err);
            });
          }
        });
      }

      // Thumbnails clicks
      this.thumbs.forEach(thumb => {
        thumb.addEventListener('click', (e) => {
          this.stopAutoplay();
          const idx = parseInt(thumb.getAttribute('data-thumb-index'), 10);
          this.goTo(idx);
        });
      });

      // Main Gallery Arrow Clicks
      const galleryNext = this.querySelector('[data-gallery-next]');
      if (galleryNext) {
        galleryNext.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.stopAutoplay();
          this.goNext();
        });
      }
      
      const galleryPrev = this.querySelector('[data-gallery-prev]');
      if (galleryPrev) {
        galleryPrev.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.stopAutoplay();
          this.goPrev();
        });
      }

      // Lightbox Open
      const openTrigger = this.querySelector('[data-open-lightbox]');
      if (openTrigger) {
        openTrigger.addEventListener('click', (e) => {
          if (this.isSwiping) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          // Do not open lightbox if clicking video/iframe/model-viewer directly
          if (e.target.tagName === 'VIDEO' || e.target.closest('video') || e.target.tagName === 'IFRAME' || e.target.closest('iframe') || e.target.tagName === 'MODEL-VIEWER' || e.target.closest('model-viewer')) {
            return;
          }
          this.openLightbox();
        });
      }

      // Lightbox Close
      if (this.lightbox) {
        this.lightbox.querySelectorAll('[data-close-lightbox]').forEach(btn => {
          btn.addEventListener('click', () => this.closeLightbox());
        });
        
        // Next/Prev buttons
        const next = this.lightbox.querySelector('[data-lightbox-next]');
        if (next) next.addEventListener('click', () => this.goNext());
        
        const prev = this.lightbox.querySelector('[data-lightbox-prev]');
        if (prev) prev.addEventListener('click', () => this.goPrev());

        // Keyboard navigation
        document.addEventListener('keydown', (e) => {
          if (this.lightbox.style.display === 'flex') {
            if (e.key === 'Escape') this.closeLightbox();
            if (e.key === 'ArrowRight') this.goNext();
            if (e.key === 'ArrowLeft') this.goPrev();
          }
        });
      }

      // Start autoplay
      this.startAutoplay();

      // Pause on hover
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());

      // Setup Swipe / Drag navigation
      this.setupSwipe(this.querySelector('.product-gallery__main'));
      this.setupSwipe(this.querySelector('.lightbox__stage'));

      // Trigger initial media display
      this.goTo(0);
    }

    setupSwipe(el) {
      if (!el) return;
      let startX = 0;
      let startY = 0;
      let isDragging = false;
      this.isSwiping = false;

      el.querySelectorAll('img').forEach(img => {
        img.addEventListener('dragstart', (e) => e.preventDefault());
      });
      el.addEventListener('dragstart', (e) => e.preventDefault());

      const onStart = (e) => {
        if (this.images.length <= 1) return;
        const target = e.target;
        if (target && (target.tagName === 'MODEL-VIEWER' || target.closest('model-viewer') || target.tagName === 'VIDEO' || target.closest('video') || target.tagName === 'IFRAME' || target.closest('iframe'))) {
          isDragging = false;
          return;
        }
        const currentMedia = this.media[this.currentIndex];
        if (currentMedia && (currentMedia.type === 'model' || currentMedia.type === 'video' || currentMedia.type === 'external_video')) {
          isDragging = false;
          return;
        }
        this.stopAutoplay();
        isDragging = true;
        startX = e.touches ? e.touches[0].clientX : e.clientX;
        startY = e.touches ? e.touches[0].clientY : e.clientY;
      };

      const onMove = (e) => {
        if (!isDragging) return;
        const currentMedia = this.media[this.currentIndex];
        if (currentMedia && (currentMedia.type === 'model' || currentMedia.type === 'video' || currentMedia.type === 'external_video')) {
          isDragging = false;
          return;
        }
        const currentX = e.touches ? e.touches[0].clientX : e.clientX;
        const currentY = e.touches ? e.touches[0].clientY : e.clientY;
        const diffX = currentX - startX;
        const diffY = currentY - startY;

        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 10) {
          this.isSwiping = true;
        }
      };

      const onEnd = (e) => {
        if (!isDragging) return;
        isDragging = false;
        const endX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
        const diffX = endX - startX;

        if (Math.abs(diffX) > 40 && this.isSwiping) {
          if (diffX < 0) {
            this.goNext();
          } else {
            this.goPrev();
          }
        }

        if (this.isSwiping) {
          setTimeout(() => { this.isSwiping = false; }, 50);
        }
        this.startAutoplay();
      };

      el.addEventListener('touchstart', onStart, { passive: true });
      el.addEventListener('touchmove', onMove, { passive: true });
      el.addEventListener('touchend', onEnd);

      el.addEventListener('mousedown', (e) => {
        if (e.button !== 0) return;
        onStart(e);
      });
      el.addEventListener('mousemove', onMove);
      window.addEventListener('mouseup', (e) => {
        if (isDragging) onEnd(e);
      });
    }

    startAutoplay() {
      if (this.images.length > 1 && !this.autoplayInterval) {
        // If current media is a video or 3D model, do not autoplay slides
        const currentMedia = this.media[this.currentIndex];
        if (currentMedia && (currentMedia.type === 'video' || currentMedia.type === 'external_video' || currentMedia.type === 'model')) {
          return;
        }
        this.autoplayInterval = setInterval(() => {
          this.goNext();
        }, 3000);
      }
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }

    goTo(index) {
      if (index < 0 || index >= this.images.length) return;
      this.currentIndex = index;
      const currentMedia = this.media[index];
      
      // Update active thumbnails
      this.thumbs.forEach(btn => {
        const btnIdx = parseInt(btn.getAttribute('data-thumb-index'), 10);
        if (btnIdx === index) {
          btn.classList.add('product-gallery__thumb-btn--active');
          
          // Scroll the parent container relatively to center/show the active thumb, avoiding page scroll jump
          const parent = btn.parentElement;
          if (parent) {
            if (parent.classList.contains('product-gallery__thumbs')) {
              // Vertical desktop container
              const offsetTop = btn.offsetTop - parent.offsetTop - (parent.clientHeight / 2) + (btn.clientHeight / 2);
              parent.scrollTo({ top: offsetTop, behavior: 'smooth' });
            } else if (parent.classList.contains('product-gallery__thumbs-mobile')) {
              // Horizontal mobile container
              const offsetLeft = btn.offsetLeft - parent.offsetLeft - (parent.clientWidth / 2) + (btn.clientWidth / 2);
              parent.scrollTo({ left: offsetLeft, behavior: 'smooth' });
            }
          }
        } else {
          btn.classList.remove('product-gallery__thumb-btn--active');
        }
      });

      // Update Main image / video / 3D model container
      if (this.mainImg) {
        if (currentMedia && (currentMedia.type === 'video' || currentMedia.type === 'external_video' || currentMedia.type === 'model') && currentMedia.html) {
          this.mainImg.style.display = 'none';
          if (this.mainVideoContainer) {
            this.mainVideoContainer.innerHTML = currentMedia.html;
            this.mainVideoContainer.style.display = 'block';
            const videoEl = this.mainVideoContainer.querySelector('video');
            if (videoEl) {
              videoEl.setAttribute('controls', 'true');
              videoEl.play().catch(() => {});
            }
            const modelEl = this.mainVideoContainer.querySelector('model-viewer');
            if (modelEl) {
              modelEl.setAttribute('camera-controls', 'true');
              modelEl.setAttribute('touch-action', 'none');
              modelEl.setAttribute('interaction-prompt', 'none');
              modelEl.setAttribute('reveal', 'auto');
              modelEl.style.pointerEvents = 'auto';
            }
          }
        } else {
          if (this.mainVideoContainer) {
            this.mainVideoContainer.style.display = 'none';
            this.mainVideoContainer.innerHTML = '';
          }
          this.mainImg.style.display = 'block';
          
          this.mainImg.classList.add('fade-out');
          setTimeout(() => {
            this.mainImg.src = this.images[index];
            const onImgLoad = () => {
              this.mainImg.classList.remove('fade-out');
              this.mainImg.removeEventListener('load', onImgLoad);
            };
            if (this.mainImg.complete) {
              this.mainImg.classList.remove('fade-out');
            } else {
              this.mainImg.addEventListener('load', onImgLoad);
            }
          }, 150);
        }
      }
      
      // Update Lightbox image / video / 3D model container
      if (this.lightboxImg) {
        if (currentMedia && (currentMedia.type === 'video' || currentMedia.type === 'external_video' || currentMedia.type === 'model') && currentMedia.html) {
          this.lightboxImg.style.display = 'none';
          if (this.lightboxVideoContainer) {
            this.lightboxVideoContainer.innerHTML = currentMedia.html;
            this.lightboxVideoContainer.style.display = 'flex';
            const videoEl = this.lightboxVideoContainer.querySelector('video');
            if (videoEl) {
              videoEl.setAttribute('controls', 'true');
              videoEl.play().catch(() => {});
            }
            const modelEl = this.lightboxVideoContainer.querySelector('model-viewer');
            if (modelEl) {
              modelEl.setAttribute('camera-controls', 'true');
              modelEl.setAttribute('touch-action', 'none');
              modelEl.setAttribute('interaction-prompt', 'none');
              modelEl.setAttribute('reveal', 'auto');
              modelEl.style.pointerEvents = 'auto';
            }
          }
        } else {
          if (this.lightboxVideoContainer) {
            this.lightboxVideoContainer.style.display = 'none';
            this.lightboxVideoContainer.innerHTML = '';
          }
          this.lightboxImg.style.display = 'block';
          this.lightboxImg.src = this.images[index];
        }
      }
      
      // Update counters
      if (this.currentIndexSpan) this.currentIndexSpan.textContent = index + 1;
      if (this.lightboxIndexSpan) this.lightboxIndexSpan.textContent = index + 1;

      // Hide/show main gallery navigation arrows based on visible images count
      const mainPrev = this.querySelector('[data-gallery-prev]');
      const mainNext = this.querySelector('[data-gallery-next]');
      if (mainPrev && mainNext) {
        if (this.images.length <= 1) {
          mainPrev.style.display = 'none';
          mainNext.style.display = 'none';
        } else {
          mainPrev.style.display = '';
          mainNext.style.display = '';
        }
      }
    }

    goNext() {
      const nextIdx = (this.currentIndex + 1) % this.images.length;
      this.goTo(nextIdx);
    }

    goPrev() {
      const prevIdx = (this.currentIndex - 1 + this.images.length) % this.images.length;
      this.goTo(prevIdx);
    }

    openLightbox() {
      this.stopAutoplay();
      // Pause gallery video if active
      if (this.mainVideoContainer) {
        const videoEl = this.mainVideoContainer.querySelector('video');
        if (videoEl) videoEl.pause();
      }
      if (this.lightbox) {
        if (this.lightbox.parentElement !== document.body) {
          document.body.appendChild(this.lightbox);
        }
        this.lightbox.style.display = 'flex';
        document.documentElement.classList.add('drawer-open');
        this.goTo(this.currentIndex);
      }
    }

    closeLightbox() {
      if (this.lightbox) {
        this.lightbox.style.display = 'none';
        document.documentElement.classList.remove('drawer-open');
        // Clean up video player inside lightbox to stop background audio/playing
        if (this.lightboxVideoContainer) {
          this.lightboxVideoContainer.innerHTML = '';
        }
      }
      this.startAutoplay();
    }

    filterByColor(color) {
      if (!color) return;
      this.stopAutoplay();
      const lowerColor = color.toLowerCase();
      
      // Filter the original media list
      const matched = this.allMedia.filter(item => {
        const alt = (item.alt || '').toLowerCase();
        const url = (item.url || item.preview_url || '').toLowerCase();
        return alt.includes(lowerColor) || url.includes(lowerColor);
      });
      
      // Fallback if no media matches
      this.media = matched.length > 0 ? matched : this.allMedia;
      this.images = this.media.map(m => m.url || m.preview_url || m);
      
      // Update desktop thumbnails visibility and their data-thumb-index attributes
      const desktopThumbs = Array.from(this.querySelectorAll('.product-gallery__thumbs .product-gallery__thumb-btn'));
      desktopThumbs.forEach((thumb, idx) => {
        const item = this.allMedia[idx];
        const imgUrl = item ? (item.url || item.preview_url || item) : '';
        const newIdx = this.images.indexOf(imgUrl);
        
        if (newIdx !== -1) {
          thumb.style.display = '';
          thumb.setAttribute('data-thumb-index', newIdx);
        } else {
          thumb.style.display = 'none';
          thumb.removeAttribute('data-thumb-index');
        }
      });
      
      // Update mobile thumbnails as well (if separate buttons exist)
      const mobileThumbs = Array.from(this.querySelectorAll('.product-gallery__thumbs-mobile .product-gallery__thumb-btn'));
      mobileThumbs.forEach((thumb, idx) => {
        const item = this.allMedia[idx];
        const imgUrl = item ? (item.url || item.preview_url || item) : '';
        const newIdx = this.images.indexOf(imgUrl);
        
        if (newIdx !== -1) {
          thumb.style.display = '';
          thumb.setAttribute('data-thumb-index', newIdx);
        } else {
          thumb.style.display = 'none';
          thumb.removeAttribute('data-thumb-index');
        }
      });
      
      // Re-assign this.thumbs list to only visible ones for arrow nav and keyboard interactions
      this.thumbs = Array.from(this.querySelectorAll('.product-gallery__thumb-btn')).filter(btn => btn.style.display !== 'none');
      
      // Update total counts in UI
      const countLabel = this.querySelector('.product-gallery__counter');
      if (countLabel) {
        const lastChild = countLabel.lastChild;
        if (lastChild && lastChild.nodeType === Node.TEXT_NODE) {
          lastChild.textContent = ` / ${this.images.length}`;
        }
      }
      const lightboxCounter = this.querySelector('.lightbox__counter');
      if (lightboxCounter) {
        const lastChild = lightboxCounter.lastChild;
        if (lastChild && lastChild.nodeType === Node.TEXT_NODE) {
          lastChild.textContent = ` / ${this.images.length}`;
        }
      }
      
      // Select the first image in the filtered list
      this.goTo(0);
      
      // Re-evaluate autoplay
      this.startAutoplay();
    }
  }

  customElements.define('product-gallery-component', ProductGallery);

  // ----------------------------------------------------
  // Dynamic Product Page Variant Selector
  // ----------------------------------------------------
  class ProductVariantSelector {
    constructor() {
      this.section = document.querySelector('.product-page-section');
      if (!this.section) return;

      this.variantIdInput = document.getElementById('ProductVariantIdInput');
      this.buyNowVariantInput = document.getElementById('ProductBuyNowVariantId');
      
      this.addToCartBtn = document.getElementById('ProductAddToCartBtn');
      this.buyNowForm = document.getElementById('ProductBuyNowForm');
      
      this.product = null;
      this.selectedOptions = {};
      
      this.init();
    }

    init() {
      const productJson = document.getElementById('ProductPageJsonData');
      if (!productJson) return;

      try {
        this.product = JSON.parse(productJson.textContent);
        
        // Grab current selection
        this.section.querySelectorAll('.product-option-group').forEach(group => {
          const activeBtn = group.querySelector('.swatch-image-btn--active, .option-pill-btn--active');
          if (activeBtn) {
            const name = activeBtn.getAttribute('data-option-select');
            const val = activeBtn.getAttribute('data-option-value');
            this.selectedOptions[name] = val;
          }
        });

        // Add click events to selector buttons
        this.section.querySelectorAll('[data-option-select]').forEach(btn => {
          btn.addEventListener('click', (e) => {
            const name = btn.getAttribute('data-option-select');
            const val = btn.getAttribute('data-option-value');
            this.selectedOptions[name] = val;
            
            if (name === 'Color' || name === 'Colour') {
              const gallery = document.querySelector('product-gallery-component');
              if (gallery && typeof gallery.filterByColor === 'function') {
                gallery.filterByColor(val);
              }
            }
            
            this.updateUI(group => {
              const selectEl = group.querySelector('[data-option-select]');
              if (!selectEl) return;
              const groupName = selectEl.getAttribute('data-option-select');
              group.querySelectorAll('[data-option-select]').forEach(b => {
                const bVal = b.getAttribute('data-option-value');
                if (bVal === this.selectedOptions[groupName]) {
                  b.classList.add('swatch-image-btn--active', 'option-pill-btn--active');
                } else {
                  b.classList.remove('swatch-image-btn--active', 'option-pill-btn--active');
                }
              });
            });
            
            this.updateSelection();
          });
        });

        // Sync gallery filter on load
        const initialColor = this.selectedOptions['Color'] || this.selectedOptions['Colour'];
        if (initialColor) {
          const gallery = document.querySelector('product-gallery-component');
          if (gallery && typeof gallery.filterByColor === 'function') {
            gallery.filterByColor(initialColor);
          }
        }
      } catch (err) {
        console.error('[VariantSelector] Init error:', err);
      }
    }

    updateUI(callback) {
      this.section.querySelectorAll('.product-option-group').forEach(callback);
    }

    updateSelection() {
      // Find matching variant
      const variant = this.product.variants.find(v => {
        return v.options.every((optVal, idx) => {
          const optName = this.product.options[idx].name;
          return this.selectedOptions[optName] === optVal;
        });
      });

      // Update Color Swatch label
      const colorLabel = document.getElementById('SelectedColorLabel');
      if (colorLabel && this.selectedOptions['Color']) {
        colorLabel.textContent = this.selectedOptions['Color'];
      } else if (colorLabel && this.selectedOptions['Colour']) {
        colorLabel.textContent = this.selectedOptions['Colour'];
      }

      if (variant) {
        // Update input ID
        this.variantIdInput.value = variant.id;
        if (this.buyNowVariantInput) this.buyNowVariantInput.value = variant.id;
        
        // Update Price display
        const priceText = `Rs. ${Math.round(variant.price / 100).toLocaleString('en-IN')}`;
        document.getElementById('ProductPagePrice').textContent = priceText;
        const floatPrice = document.getElementById('ProductFloatingBarPrice');
        if (floatPrice) floatPrice.textContent = priceText;

        const compareEl = document.getElementById('ProductPageComparePrice');
        const badgeEl = document.getElementById('ProductPageSaveBadge');

        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const compPriceText = `Rs. ${Math.round(variant.compare_at_price / 100).toLocaleString('en-IN')}`;
          compareEl.textContent = compPriceText;
          compareEl.style.display = 'inline';
          
          const discount = variant.compare_at_price - variant.price;
          const percentage = Math.round((discount * 100) / variant.compare_at_price);
          badgeEl.textContent = `SAVE ${percentage}%`;
          badgeEl.style.display = 'inline';
        } else {
          compareEl.style.display = 'none';
          badgeEl.style.display = 'none';
        }

        // Update button states
        if (variant.available) {
          this.addToCartBtn.disabled = false;
          this.addToCartBtn.innerHTML = 'ADD TO CART<i class="material-symbols-outlined ph-light ph-arrow-right"></i>';
          if (this.buyNowForm) this.buyNowForm.style.display = 'block';
          const floatAdd = document.getElementById('FloatingAddToCartBtn');
          if (floatAdd) {
            floatAdd.disabled = false;
            floatAdd.textContent = 'ADD TO CART';
          }
          const floatBuy = document.getElementById('FloatingBuyNowBtn');
          if (floatBuy) floatBuy.style.display = 'flex';
        } else {
          this.addToCartBtn.disabled = true;
          this.addToCartBtn.textContent = 'SOLD OUT';
          if (this.buyNowForm) this.buyNowForm.style.display = 'none';
          const floatAdd = document.getElementById('FloatingAddToCartBtn');
          if (floatAdd) {
            floatAdd.disabled = true;
            floatAdd.textContent = 'SOLD OUT';
          }
          const floatBuy = document.getElementById('FloatingBuyNowBtn');
          if (floatBuy) floatBuy.style.display = 'none';
        }

        // Swap main gallery image to variant's image if available
        if (variant.image) {
          const floatImg = document.getElementById('ProductFloatingBarImage');
          if (floatImg) floatImg.src = variant.image;
          const gallery = document.querySelector('product-gallery-component');
          if (gallery) {
            gallery.stopAutoplay();
            const imageIdx = gallery.images.indexOf(variant.image);
            if (imageIdx !== -1) {
              gallery.goTo(imageIdx);
            } else {
              // Set image directly if not found in list (fallback)
              const mainImg = document.getElementById('ProductMainImage');
              if (mainImg) {
                mainImg.classList.add('fade-out');
                setTimeout(() => {
                  mainImg.src = variant.image;
                  const onImgLoad = () => {
                    mainImg.classList.remove('fade-out');
                    mainImg.removeEventListener('load', onImgLoad);
                  };
                  if (mainImg.complete) {
                    mainImg.classList.remove('fade-out');
                  } else {
                    mainImg.addEventListener('load', onImgLoad);
                  }
                }, 150);
              }
            }
          }
        }
      } else {
        this.variantIdInput.value = '';
        this.addToCartBtn.disabled = true;
        this.addToCartBtn.textContent = 'SOLD OUT';
        if (this.buyNowForm) this.buyNowForm.style.display = 'none';
        const floatAdd = document.getElementById('FloatingAddToCartBtn');
        if (floatAdd) {
          floatAdd.disabled = true;
          floatAdd.textContent = 'SOLD OUT';
        }
        const floatBuy = document.getElementById('FloatingBuyNowBtn');
        if (floatBuy) floatBuy.style.display = 'none';
      }
    }
  }

  // Init Variant selector after DOM finishes loading
  const initProductScript = () => {
    new ProductVariantSelector();

    // Size Chart Modal Toggle
    const sizeChartTriggers = document.querySelectorAll('[data-open-size-chart]');
    const sizeChartModal = document.getElementById('ProductSizeChartModal');
    if (sizeChartModal) {
      const openModal = () => {
        sizeChartModal.style.display = 'flex';
        document.documentElement.classList.add('drawer-open');
      };
      const closeModal = () => {
        sizeChartModal.style.display = 'none';
        document.documentElement.classList.remove('drawer-open');
      };

      sizeChartTriggers.forEach(trigger => {
        trigger.addEventListener('click', openModal);
      });

      sizeChartModal.querySelectorAll('[data-close-size-chart]').forEach(btn => {
        btn.addEventListener('click', closeModal);
      });

      // Escape key to close
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && sizeChartModal.style.display === 'flex') {
          closeModal();
        }
      });

      // Unit Toggling (IN / CM)
      const unitBtns = sizeChartModal.querySelectorAll('.unit-btn');
      const unitVals = sizeChartModal.querySelectorAll('.unit-val');
      unitBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          const targetUnit = btn.getAttribute('data-unit');
          unitBtns.forEach(b => b.classList.toggle('unit-btn--active', b === btn));
          unitVals.forEach(val => {
            const newVal = val.getAttribute(`data-${targetUnit}`);
            if (newVal) {
              val.textContent = newVal;
            }
          });
        });
      });
    }

    // Bottom floating bar scroll listener & action binding
    const mainAddToCartBtn = document.getElementById('ProductAddToCartBtn');
    const floatingBar = document.getElementById('ProductFloatingBar');
    if (mainAddToCartBtn && floatingBar) {
      const handleScroll = () => {
        const isMobile = window.innerWidth < 768;
        const rect = mainAddToCartBtn.getBoundingClientRect();
        
        if (isMobile) {
          // Mobile logic:
          // 1. Visible when page opens (above main ATC button)
          // 2. Hidden when main ATC button section is in viewport
          // 3. Visible again when scrolled past main ATC button section
          const vh = window.innerHeight;
          const isMainBtnInViewport = (rect.top < vh) && (rect.bottom > 0);
          
          if (isMainBtnInViewport) {
            floatingBar.classList.remove('active');
          } else {
            floatingBar.classList.add('active');
          }
        } else {
          // Desktop logic: Show after scrolling past main ATC button
          if (rect.bottom < 0) {
            floatingBar.classList.add('active');
          } else {
            floatingBar.classList.remove('active');
          }
        }
      };
      window.addEventListener('scroll', handleScroll, { passive: true });
      window.addEventListener('resize', handleScroll, { passive: true });
      // Run once on load
      handleScroll();

      // Bind actions on the floating bar buttons
      const floatAddToCart = document.getElementById('FloatingAddToCartBtn');
      if (floatAddToCart) {
        floatAddToCart.addEventListener('click', () => {
          mainAddToCartBtn.click();
        });
      }

      const floatBuyNow = document.getElementById('FloatingBuyNowBtn');
      const mainBuyNowBtn = document.querySelector('.btn-buy-now');
      if (floatBuyNow && mainBuyNowBtn) {
        floatBuyNow.addEventListener('click', () => {
          mainBuyNowBtn.click();
        });
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductScript);
  } else {
    initProductScript();
  }

  } catch(e) { console.error(e); }
})();
})();
